import React, { useLayoutEffect } from 'react';

import './dopi.css';
import { isMobile } from 'react-device-detect';


const Dolpa=()=>{
    useLayoutEffect(()=>{
        window.scrollTo(0,0);
    },[]);

document.title = "회사소개 - 돌파공모";
return(
<div className='doll'>
<h3>돌파공모</h3>
<h3>지속 성장을 위한 소중한 자극제, 공모전!</h3>
<p>끊임없이 도전하고, 배우고, 성취하는 순환에서 자신의 미래는 더욱 밝아진다</p>
<p>더욱 효율적으로 성장의 돌파를 일궈낼 수 있도록 돌파공모가 응원합니다</p>
<div className={isMobile ? 'munjin baia' : 'munjin muia'}><img src={process.env.PUBLIC_URL+`/inda/champo.jpg`} /></div>  
</div>
);

};

export default Dolpa;